// export { default as login } from './login/login.vue';
// export { default as retrieve } from './retrieve/retrieve.vue';
export const userLogin = (r) => require.ensure([], () => r(require("./login/login.vue")), "userLogin");
export const userRetrieve = (r) => require.ensure([], () => r(require("./retrieve/retrieve.vue")), "userRetrieve");
export const orgInfo = (r) => require.ensure([], () => r(require("./orgInfo/orgInfo.vue")), "orgInfo");
